/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./InputDropDown.css";
import cross from "../../../images/Cross.svg";

import React from "react";

import Input from "components/ThreeKey/Input";

import { InputDropDownProps, InputDropDownState } from "./InputDropDown.types";

export default class InputDropDown extends React.Component<InputDropDownProps, InputDropDownState> {

   private componentClassName: string;

   private inputRef: React.RefObject<Input>;
   private dropDownRef: React.RefObject<HTMLDivElement>;

   constructor(props: InputDropDownProps) {

      super(props);

      this.componentClassName = "tk-input-drop-down" + (this.props.componentName ? `-${this.props.componentName}` : "");

      this.inputRef = React.createRef<Input>();
      this.dropDownRef = React.createRef<HTMLDivElement>();

      this.state = {
         value: props.value || "",
         selectedItem: -1,
         items: props.items || [],
         droppedDown: false,
         inputFocused: false
      }

   }

   public componentDidUpdate(prevProps: InputDropDownProps, prevState: InputDropDownState) {

      if (prevProps.items !== this.props.items) {

         this.setState({ items: this.props.items || [] });

         if (prevProps.items && this.props.items) {

            if (prevProps.items.length > this.props.items?.length) {
               this.setState({ selectedItem: -1 });
               this.dropDownRef.current?.scrollTo({top: 0});
            } else {

               for (let i = 0; i < prevProps.items.length; i++) {
                  if (prevProps.items[i] !== this.props.items[i]) {
                     this.setState({ selectedItem: -1 });
                     this.dropDownRef.current?.scrollTo({top: 0});
                     break;
                  }
               }

            }

         } else {

            this.setState({ selectedItem: -1 });
            this.dropDownRef.current?.scrollTo({top: 0});

         }

         //this.selectFirstFoundItem(this.state.value);

      }

      if (prevProps.value !== this.props.value || (this.props.value !== undefined && this.props.value !== this.state.value)) {

         const value = this.props.value || "";
         this.setState({ value });
         this.selectFirstFoundItem(value);

      }

      if (this.props.value && this.props.value !== this.state.value) {

         setTimeout(() => {
            const value = this.props.value || "";
            this.setState({ value });
            this.selectFirstFoundItem(value);
         }, 0);

      }

      /*if (!this.state.droppedDown && this.state.items && this.state.items.length > 0 && this.state.inputFocused && this.props.readonly) {
         this.setState({ droppedDown: true });
      }*/

      if (this.state.droppedDown && (!this.state.items || this.state.items.length === 0)) {
         this.setState({ droppedDown: false });
      }

      if (this.state.droppedDown && !prevState.droppedDown) {
         // this.setState({ selectedItem: 0 });
      }

   }

   public componentDidMount() {
      window.addEventListener("mousedown", this.onWindowEvent);
      window.addEventListener("blur", this.onWindowEvent);
      window.addEventListener("keydown", this.onWindowKeyDown);

      this.dropDownRef.current?.addEventListener("scroll", this.onDropDownScroll);
   }


   public componentWillUnmount() {
      window.removeEventListener("mousedown", this.onWindowEvent);
      window.removeEventListener("blur", this.onWindowEvent);
      window.removeEventListener("keydown", this.onWindowKeyDown);

      this.dropDownRef.current?.removeEventListener("scroll", this.onDropDownScroll);
   }


   public render(): React.ReactNode {

      const icons = [
         <div key="spinner" className="spinner-container"><div className="spinner" data-visible={this.props.isLoading}></div></div>,
         <div key="dropdown" className="icon-down" data-down={this.state.droppedDown} onMouseDown={this.onIconDownMouseDown}></div>
      ];

      if (this.props.canClear) {
         icons.push((<img key="clear" className="icon-cross" src={cross} alt="x" onMouseDown={this.onIconClearMouseDown} />));
      }

      return (

         <div className={this.componentClassName} onKeyDown={this.onKeyDown}>

            <Input
               ref={this.inputRef}
               id={this.props.id}
               value={this.state.value}
               autoComplete="off"
               icons={icons}
               readOnly={this.props.readOnly}
               onChange={this.onInputChange}
               onFocus={this.onInputFocus}
               onBlur={this.onInputBlur}
               onMouseDown={this.onInputMouseDown}
               valid={this.props.valid}
               validText={this.props.validText}
               invalidText={this.props.invalidText}
               disabled={this.props.disabled}
            />

            <div className="drop-down-container">

               <div className="absFix">

                  <div ref={this.dropDownRef} className="drop-down" data-visible={this.state.droppedDown} onMouseDown={this.onDropDownMouseDown} >

                     <div className="spinner-container"><div className="spinner" data-visible={this.props.isLoadingNext}></div></div>

                     { this.state.items.map((value, index) => {
                        return <div key={index} data-selected={index === this.state.selectedItem}>{value}</div>
                     })}


                  </div>

               </div>

            </div>

         </div>
      )
   }


   private onIconDownMouseDown = (e: React.MouseEvent<HTMLImageElement>) => {
      if (this.props.disabled) return;
      this.setState({ droppedDown: !this.state.droppedDown });
      this.inputRef.current?.focus();
      e.preventDefault();
      e.stopPropagation();
   }


   private onIconClearMouseDown = (e: React.MouseEvent<HTMLImageElement>) => {
      if (this.props.disabled) return;
      this.setState({ droppedDown: false });
      if (this.state.value === "") return;
      this.setState({value: ""});
      if (this.props.onChange) this.props.onChange("");
      e.preventDefault();
      e.stopPropagation();
   }


   private onInputChange = (value: string | number) => {

      if (this.props.disabled) return;

      this.setState({ value: value.toString() });
      if (this.props.onChange) this.props.onChange(value as string);

      this.selectFirstFoundItem(value.toString());

   }


   private onWindowEvent = (event: Event) => {

      // Handle window blur
      if (!(event instanceof MouseEvent)) {

         this.setState({ droppedDown: false });

         return;
      }

   }


   private onWindowKeyDown = (event: KeyboardEvent) => {

      if (this.props.disabled) return;

      if (event.key === "ArrowDown") {
         event.preventDefault();
         event.stopPropagation();
      }

      if (event.key === "ArrowUp") {
         event.preventDefault();
         event.stopPropagation();
      }

   }


   private onInputFocus = (event: React.FocusEvent) => {

      if (this.props.disabled) return;

      if (this.state.items.length > 0 && this.props.dropDownOnFocus) this.setState({ droppedDown: true });
      this.setState({ inputFocused: true, selectedItem: -1 });

   }

   private onInputBlur = (event: React.FocusEvent) => {
      this.setState({ droppedDown: false, inputFocused: false });
   }

   private onInputMouseDown = (event: React.MouseEvent) => {

      if (this.props.disabled) return;
      if (this.state.items.length > 0 && this.props.dropDownOnFocus) this.setState({ droppedDown: true });

   }

   private onDropDownMouseDown = (event: React.MouseEvent) => {

      if (event.target === this.dropDownRef.current) return;

      const index = Array.prototype.indexOf.call(this.dropDownRef.current?.children, event.target) - 1;
      this.setState({ droppedDown: false });

      if (this.state.items.length > 0 && index >= 0 && this.state.value !== this.state.items[index]) {
         this.setState({ value: this.state.items[index] });
         if (this.props.onChange) this.props.onChange(this.state.items[index]);
      }

      event.stopPropagation();

   }


   private onDropDownScroll = () => {

      const el = this.dropDownRef.current;

      if (el && el.scrollHeight - el.scrollTop === el.clientHeight && this.props.onLoadNext && !this.props.isLoadingNext) {
         this.props.onLoadNext();
      }

   }

   private onKeyDown = (event: React.KeyboardEvent) => {

      if (this.props.disabled) return;

      const noItems = this.dropDownRef.current ? this.dropDownRef.current.children.length - 1 : -1;

      if (!this.dropDownRef.current || noItems === 0) {
         this.setState({ selectedItem: -1 });
         return;
      }

      let selectedItem = this.state.selectedItem;

      const zeroItem = (this.dropDownRef.current?.children[1] as HTMLDivElement);
      let height = zeroItem.offsetHeight;
      height += parseInt(window.getComputedStyle(zeroItem).getPropertyValue("margin-top"));
      height += parseInt(window.getComputedStyle(zeroItem).getPropertyValue("margin-bottom"));

      let itemsInView = Math.floor(this.dropDownRef.current.clientHeight / height) + 1;

      switch(event.key) {

         case "ArrowDown":
            if (this.state.droppedDown) selectedItem++;
            this.setState({ droppedDown: true });
            break;

         case "ArrowUp":
            if (this.state.droppedDown) selectedItem--;
            this.setState({ droppedDown: true });
            break;

         case "PageUp":
            if (this.state.droppedDown) selectedItem -= itemsInView;
            this.setState({ droppedDown: true });
            break;

         case "PageDown":
            if (this.state.droppedDown) selectedItem += itemsInView;
            this.setState({ droppedDown: true });
            break;

         case "Home":
            if (this.state.droppedDown && !event.shiftKey) {
               selectedItem = 0;
               event.stopPropagation();
               event.preventDefault();
            } else return;
            break;

         case "End":
            if (this.state.droppedDown && !event.shiftKey) {
               selectedItem = this.state.items.length - 1;
               event.stopPropagation();
               event.preventDefault();
            } else return;
            break;

         case "Enter":
         case "Tab":
            if (event.key === "Tab") {
               if (!this.state.droppedDown) return;
               //if (this.state.value !== this.state.items[selectedItem]) return
            }

            if (this.state.items.length > 0 && selectedItem >= 0) {
               this.setState({ value: this.state.items[selectedItem], droppedDown: false });
               if (this.props.onChange) this.props.onChange(this.state.items[selectedItem]);
               if (!this.props.readOnly && event.key !== "Tab") setTimeout(() => { this.inputRef.current?.select(); }, 10);
            }

            return;

         case "Escape":
            if (this.state.droppedDown) {
               this.setState({ droppedDown: false });
               event.stopPropagation();
               event.preventDefault();
            }
            return;

         case "Shift":
         case "Control":
         case "Alt":
            return;

         default:
            if (this.props.dropDownOnKeyDown) this.setState({ droppedDown: true });
            return;

      }

      if (selectedItem < 0) selectedItem = 0;
      if (selectedItem > noItems - 1) selectedItem = noItems - 1;

      this.setState({ selectedItem });

      this.scrollToItem(selectedItem);

   }

   private selectFirstFoundItem = (value: string) => {

      if (this.props.items && this.state.droppedDown) {

         const index = this.props.items.findIndex(item => item.toLocaleLowerCase().startsWith(value.toString().toLocaleLowerCase()));

         if (index >= 0) {
            this.setState({selectedItem: index});
            this.scrollToItem(index);
         }

      }

   }

   private scrollToItem = (index: number, height?: number): void => {

      let _height: number;

      if (height) {
         _height = height;
      } else {
         const zeroItem = (this.dropDownRef.current?.children[1] as HTMLDivElement);
         _height = zeroItem.offsetHeight;
         _height += parseInt(window.getComputedStyle(zeroItem).getPropertyValue("margin-top"));
         _height += parseInt(window.getComputedStyle(zeroItem).getPropertyValue("margin-bottom"));
      }

      const item = this.dropDownRef.current?.children[index+ 1] as HTMLDivElement;
      if (!item || !this.dropDownRef.current) return;

      if (item.offsetTop + _height > this.dropDownRef.current.scrollTop + this.dropDownRef.current.clientHeight) {

         let padding = parseInt(window.getComputedStyle(this.dropDownRef.current).getPropertyValue("padding-bottom"));

         this.dropDownRef.current.scrollTo({top: item.offsetTop + _height + padding - this.dropDownRef.current?.clientHeight});

      }

      if (item.offsetTop < this.dropDownRef.current.scrollTop) {
         this.dropDownRef.current.scrollTo({top: item.offsetTop});
      }

   }


}
